(function () {
  'use strict';

  const META_QTD = 3;
  const palavras = ['camisa', 'camiseta', 'uniforme', 'jersey'];
  let verificadorAtivo = null;

  function contarCamisas(cart) {
    if (!cart || !cart.items) return 0;

    let q = 0;
    cart.items.forEach(i => {
      const t = (i.product_title || '').toLowerCase();
      const ty = (i.product_type || '').toLowerCase();
      if (palavras.some(p => t.includes(p) || ty.includes(p))) {
        q += i.quantity;
      }
    });
    return q;
  }

  function atualizarBarra(qtd) {
    const fill = document.getElementById('progress-fill');
    const text = document.getElementById('progress-text');
    if (!fill || !text) return;

    const pct = Math.min((qtd / META_QTD) * 100, 100);
    fill.style.width = pct + '%';
    text.textContent = qtd >= META_QTD
      ? '🎉 Parabéns! Você ganhou uma camisa grátis!'
      : `Adicione mais ${META_QTD - qtd} camisa(s) para ganhar 1 grátis! 🎁`;
  }

  function buscarEAtualizar() {
    fetch('/cart.js', {
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(r => r.json())
      .then(cart => {
        const qtd = contarCamisas(cart);
        atualizarBarra(qtd);
      })
      .catch(console.error);
  }

  function observarBarra() {
    const observer = new MutationObserver(() => {
      if (document.getElementById('progress-fill')) {
        buscarEAtualizar();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    observarBarra();

    // Também monitora eventos de atualização do carrinho
    [
      'cart:updated', 'cart:refresh', 'cart:open', 'drawer:open',
      'thb:cart:update', 'ajaxCart:afterUpdate', 'product:added',
      'cart.requestComplete', 'cartUpdated', 'drawerOpen'
    ].forEach(evt => {
      document.addEventListener(evt, () => {
        buscarEAtualizar();
        setTimeout(buscarEAtualizar, 300);
      });
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('button[name="add"]') || e.target.closest('[data-add-to-cart]')) {
        setTimeout(buscarEAtualizar, 400);
        setTimeout(buscarEAtualizar, 800);
        setTimeout(buscarEAtualizar, 1200);
      }
    });

    document.addEventListener('change', (e) => {
      if (e.target.matches('input[type="number"]')) {
        setTimeout(buscarEAtualizar, 300);
      }
    });

    // Inicial
    setTimeout(buscarEAtualizar, 300);
    setTimeout(buscarEAtualizar, 1000);
  });
})();
